<template>
  <a-table
    id="tableDataTabs"
    :columns="columns"
    :dataSource="data"
    :pagination="false"
    bordered> </a-table>
</template>
<script>
import { getAssetCurrDepreciate } from '@/api/assetLedger'

export default {
  props: {
    model: Object
  },
  data () {
    return {
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return index + 1
          },
          width: 50
        },
        {
          title: '折旧月份',
          dataIndex: 'peraf',
          align: 'center'
        },
        {
          title: '正常折旧TBP',
          dataIndex: 'nafaz',
          align: 'center'
        },
        {
          title: '计划外折旧TBP',
          dataIndex: 'aafaz',
          align: 'center'
        },
        {
          title: '储备金',
          dataIndex: 'mafaz',
          align: 'center'
        },
        {
          title: '重估',
          dataIndex: 'aufwz',
          align: 'center'
        }
      ],
      data: []
    }
  },
  watch: {
    model: {
      handler (model) {
        if (model) this.initValueDetail()
      },
      immediate: true
    }
  },
  methods: {
    initValueDetail () {
      const { model } = this
      const params = {
        anln1: '00' + model.anln1,
        bukrs: model.bukrs
      }
      getAssetCurrDepreciate(params).then(res => {
        if (res.status === 0) {
          this.data = res.data
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table /deep/ .ant-table-thead > tr > th {
  background: #E7F4FF !important;
  padding: 10px !important;
}
.table /deep/ .ant-table-tbody > tr > td {
  padding: 10px;
}
/deep/.ant-table-placeholder {
  position: relative !important;
}
#tableDataTabs  {
  /deep/.ant-spin-nested-loading {
    >.ant-spin-container {
      .ant-table-bordered {
        .ant-table-header > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-thead > tr > th{
          border-right: 1px solid #e8e8e8;
        }
        .ant-table-body > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr > td{
          border-right: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr.ant-table-row-selected td{
          background-color: rgba(225, 225, 225, 0);
        }
        .ant-table-footer{
          border: none !important;
        }
      }
    }
  }
}
</style>
